/**
 * Part of starter project.
 *
 * @copyright  Copyright (C) 2021 LYRASOFT.
 * @license    __LICENSE__
 */

import '@regenerator-runtime';
import '@unicorn/unicorn.js';
import { UIBootstrap5 } from '@unicorn/ui/ui-bootstrap5.js?297ef4af6591ffc5ab625708';

u.use(UIBootstrap5);

export default u;


alertify.set('notifier', 'position', 'top-right'); // top-right = 右上

u.notify = function (message, type = 'success', options = {}) {
  return alertify.notify(message, type, options.wait || 10, options.callback || null);
};
